<template>
  <div class="f360-checkbox">
    <el-checkbox v-bind="$attrs" class="f360-checkbox__input">
      <slot v-if="$slots.default" />
      <span class="f360-checkbox__label" v-else>{{ label }}</span>
    </el-checkbox>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label?: string;
}>();
</script>

<style lang="scss">
.f360-checkbox {
  &__input {
    .financas-checkbox {
      &__label {
        @include font-schema(0.75rem, 400, 1.125rem);
      }

      &__inner {
        width: 16px;
        height: 16px;
        border-radius: 4px;

        &::after {
          left: 7px;
          top: 6.2px;
        }
      }
    }

    &.is-disabled {
      .financas-checkbox {
        &__inner {
          &::after {
            left: 7px;
            top: 6.2px;
            border-color: _map.get($map: $neutro2, $key: 50) !important;
          }
        }
      }
    }
  }
}
</style>
